import { Controller, useFormContext } from "react-hook-form";
import { DatePicker } from "@luna-restaurant/ui";
export function FormDatePicker({ name, ...inputProps }) {
    const { control } = useFormContext();
    return (<Controller control={control} name={name} render={({ field: { onChange, onBlur, value }, fieldState }) => (<DatePicker value={value} onChange={onChange} onBlur={onBlur} error={fieldState.error?.message ?? false} {...inputProps}/>)}/>);
}
//# sourceMappingURL=FormDatePicker.js.map